<template>
  <div class="white-box mr-2 ml-2" v-if="customer_behavior_context_loaded">
    <h5 class="text-base mb-3">Produtos mais adicionados ao carrinho</h5>
    <div class="products-list">
      <div 
        v-if="topProducts.length === 0" 
        class="no-products"
      >
        <p class="text-muted">Nenhum produto encontrado</p>
      </div>
      <div 
        v-for="(product, i) in topProducts" 
        :key="'product-' + i"
        class="product-item"
      >
        <div class="product-rank">{{ i + 1 }}</div>
        <div class="product-info">
          <div class="product-name">{{ product.name }}</div>
          <div class="product-details">
            <span v-if="product.sku" class="product-sku">SKU: {{ product.sku }}</span>
            <span>{{ formatNumber(product.totalCarts) }} carrinhos</span>
            <span v-if="product.totalQuantity" class="product-details-separator">|</span>
            <span v-if="product.totalQuantity">{{ formatNumber(product.totalQuantity) }} itens</span>
          </div>
        </div>
        <div class="product-stats">
          <span class="product-converted">{{ formatNumber(product.convertedCarts) }} convertidos</span>
          <span v-if="product.conversionRate !== null" class="product-rate">{{ formatPercent(product.conversionRate) }}</span>
        </div>
      </div>
    </div>
  </div>
  <loader-box v-else height="400px" class="mb-4 mr-2 ml-2"/>
</template>

<script>
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    LoaderBox
  },
  computed: {
    customer_behavior_context_loaded() { 
      return this.$store.getters.customer_behavior_context_loaded 
    },
    topProducts() {
      const products = this.$store.getters.topProductsAdded || [];
      return products.slice(0, 10);
    }
  },
  methods: {
    formatNumber(value) {
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) {
        return '0';
      }

      return numeric.toLocaleString('pt-BR');
    },
    formatPercent(value) {
      if (value === null || value === undefined) {
        return '0%';
      }

      const numeric = Number(value);
      if (!Number.isFinite(numeric)) {
        return '0%';
      }

      const fractionDigits = numeric % 1 === 0 ? 0 : 2;
      return `${numeric.toLocaleString('pt-BR', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: 2
      })}%`;
    }
  }
}
</script>

<style scoped>
.white-box {
  padding: 1.5rem;
  padding-bottom: 1rem;
}

.products-list {
  max-height: 340px;
  overflow-y: auto;
}

.product-item {
  display: flex;
  align-items: center;
  padding: 12px 8px;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s ease;
}

.product-item:last-child {
  border-bottom: none;
}

.product-item:hover {
  background-color: #f8f9fa;
}

.product-rank {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #0BA7DA;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  margin-right: 12px;
  flex-shrink: 0;
}

.product-info {
  flex: 1;
  min-width: 0;
}

.product-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-details {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #6c757d;
}

.product-details-separator {
  color: #ced4da;
}

.product-sku {
  font-weight: 600;
  color: #495057;
}

.product-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  min-width: 120px;
  text-align: right;
}

.product-converted {
  font-size: 12px;
  color: #495057;
}

.product-rate {
  font-size: 12px;
  color: #7ABA1E;
  font-weight: 600;
}

.no-products {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
}

@media only screen and (max-width: 768px) {
  .product-item {
    flex-wrap: wrap;
  }
  
  .product-rank {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  
  .product-name {
    font-size: 13px;
  }
  
  .product-stats {
    align-items: flex-start;
    text-align: left;
    margin-top: 8px;
  }

  .product-details {
    gap: 4px;
  }
}
</style>

